import { Box, Icon, Input } from '@chakra-ui/react'
import { memo } from 'react'

import type { SwitchboardTranslateFn } from '../../types'
import { text } from '../../utils/text'

export interface SwitchboardSearchBarProps {
  /** Current search value */
  value: string
  /** Callback when search value changes */
  onChange: (value: string) => void
  /** Placeholder text */
  placeholder?: string
  /** Optional translation function for i18n */
  t?: SwitchboardTranslateFn
}

/**
 * Search input component for filtering switchboards by name
 */
export const SwitchboardSearchBar = memo<SwitchboardSearchBarProps>(
  ({ value, onChange, placeholder: placeholderProp, t }) => {
    const placeholder =
      placeholderProp ??
      text(t, 'switchboard.list.search.placeholder', 'Search by name...')
    return (
      <Box w="412px" position="relative">
        <Icon
          boxSize={4}
          color="fg.muted"
          position="absolute"
          left={3}
          top="50%"
          transform="translateY(-50%)"
          zIndex={1}
          pointerEvents="none"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
        </Icon>
        <Input
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          size="md"
          pl={10}
          bg="bg.subtle"
          borderColor="border.default"
          borderRadius="lg"
          _placeholder={{ color: 'fg.subtle' }}
          _hover={{ borderColor: 'border.emphasized' }}
          _focus={{
            borderColor: 'brand.solid',
            boxShadow: '0 0 0 1px var(--chakra-colors-brand-solid)',
          }}
        />
      </Box>
    )
  },
)

SwitchboardSearchBar.displayName = 'SwitchboardSearchBar'
